import { Dispatch } from '@reduxjs/toolkit';
import { tokenManager } from '../../../lib/token-manager';
import { getUser } from '../../../redux/user';
import { routes } from '../../routes/routes-names';
import { AuthResponseType } from '../../../types/auth';
import { closeModal } from '../../../lib/utils/close-modal';
import { AppDispatch } from '../../../redux';

export async function goToRoom(data: AuthResponseType, dispatch: AppDispatch,navigate:(path: string) => void) {
    closeModal('SignInSignUp');
    tokenManager.setToken(data.resultObject.accessToken);
    await dispatch(getUser());
    navigate(routes.dashboard);
}
